import { Component } from '@angular/core';

@Component({
  selector: 'app-recover-password-view',
  templateUrl: './recover-password-view.component.html',
  styleUrls: ['./recover-password-view.component.css'],
})
export class RecoverPasswordViewComponent {
  mailEncrypted: string;
  showInstruction: boolean = false;

  getMailEncrypted(event) {
    this.mailEncrypted = event;
    this.showInstruction = true;
  }
}
